let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("6wr18"), load("ffEVr"), load("cyGuT"), load("hhss7"), load("dGk3x")]).then(() => parcelRequire('liJpy'));